import { useAuth, useClerk } from "@clerk/react";
import { Navigate, Outlet } from "react-router-dom";

import { useSignUpMode } from "@/lib/use-public-sign-up";

const PublicSignUpGate = ({
  modes,
}: {
  modes: readonly ("public" | "waitlist")[];
}) => {
  const { isLoaded } = useAuth();
  const clerk = useClerk() as { status?: string };
  const mode = useSignUpMode();
  const settled = isLoaded || clerk.status === "error";
  if (!settled) {
    return null;
  }
  const open =
    (mode === "public" && modes.includes("public")) ||
    (mode === "waitlist" && modes.includes("waitlist"));
  if (!open) {
    return <Navigate replace to="/login" />;
  }
  return <Outlet />;
};

export default PublicSignUpGate;
